<template>
  <v-toolbar style="margin-bottom: 20px">
    <v-btn icon @click="$router.go(-1)">
      <v-icon>mdi-arrow-left</v-icon>
    </v-btn>

    <v-toolbar-title>{{ title }}</v-toolbar-title>

    <v-spacer></v-spacer>

    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon color="#34495E" dark v-bind="attrs" v-on="on">
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item
          v-for="(option, index) in options"
          :key="index"
          @click="handleOption(option.title)"
        >
          <v-list-item-title>{{ option.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-toolbar>
</template>

<script>
export default {
  name: "ListToolbar",
  props: {
    title: String
  },
  data: () => ({
    options: [
      { title: "Information" },
      { title: "Invite" },
      { title: "Sorting" }
    ]
  }),
  methods: {
    handleOption(option) {
      this.$emit("handleOption", option);
    }
  }
};
</script>
